import { render, staticRenderFns } from "./BuildingShowNewsTab.vue?vue&type=template&id=0aaf0a75"
import script from "./BuildingShowNewsTab.vue?vue&type=script&lang=ts"
export * from "./BuildingShowNewsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports